export interface Alert {
  id: string;
  message: string;
  level: AlertLevel | string;
  createdAt: string | number;
  updatedAt: string | number;
  feature: Feature | string;
  isRead: boolean;
  createdBy: string;
}

export enum AlertType {
  error = 'error',
  success = 'success',
  info = 'info',
  warning = 'warning',
  debug = 'debug'
}

export enum AlertLevel {
  error = 'times-circle',
  success = 'check-circle',
  info = 'info-circle',
  warning = 'exclamation-triangle',
  debug = 'debug'
}

export enum Feature {
  billing = 'billing',
}
